module.exports = __webpack_public_path__ + "images/emoji/microphone.2c030c63bc3d5d83a40d.png";


//////////////////
// WEBPACK FOOTER
// ./resources/images/emoji/microphone.png
// module id = A8W1
// module chunks = 13